import { UserRetailerCheckoutOrderStatusV2 } from "@/components/Checkout/types";
import { ShipmentStatus } from "../../../../../types/misc";

export const getShipmentStatus = (
  orderStatus: string | undefined,
  checkoutOrderStatus: UserRetailerCheckoutOrderStatusV2
) => {
  if (
    checkoutOrderStatus ===
      UserRetailerCheckoutOrderStatusV2.checkout_cancelled ||
    checkoutOrderStatus === UserRetailerCheckoutOrderStatusV2.checkout_error ||
    checkoutOrderStatus ===
      UserRetailerCheckoutOrderStatusV2.user_interaction_timeout
  ) {
    return "Cancelled";
  }
  if (orderStatus === ShipmentStatus.DELIVERED) {
    return "Delivered";
  }
  if (orderStatus === ShipmentStatus.CANCELLED) {
    return "Cancelled";
  }
  if (orderStatus === ShipmentStatus.SHIPPED) {
    return "Shipped";
  }
  if (orderStatus === ShipmentStatus.UNKNOWN) {
    return "Processing";
  }
  return "Processing";
};
